<template lang="pug">
    .component-dropdown(v-if="mounted")
        .dropdown-placeholder(:data-toggle="'dropdown-'+_uid")
            slot(name="placeholder")
                i(:class="icon")
        .dropdown-pane(data-close-on-click="true", :class="position", :id="'dropdown-'+_uid", data-auto-focus="true" data-dropdown="", v-f-dropdown="")
            slot
</template>
<script type="text/babel">
    export default {
        name: "Dropdown",
        components: {},
        data() {
            return {
                mounted: false
            }
        },
        mounted() {
            this.mounted = true
        },
        methods: {},
        props: ['position', 'icon']
    }
</script>
<style lang="sass" rel="stylesheet/sass">
    .dropdown-placeholder
        cursor: pointer
</style>



// WEBPACK FOOTER //
// Dropdown.vue?7394cb16